import { render, staticRenderFns } from "./Volant.vue?vue&type=template&id=296b1771&scoped=true"
import script from "./Volant.vue?vue&type=script&lang=js"
export * from "./Volant.vue?vue&type=script&lang=js"
import style0 from "./Volant.vue?vue&type=style&index=0&id=296b1771&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b1771",
  null
  
)

export default component.exports